export interface RowAction {index:number;label:string;fixed?:boolean}
export function primaryRowActions(actions:RowAction[],section:string):number[] {
 const normal=actions.filter(action=>!action.fixed)
 if(normal.length<=3)return actions.map(action=>action.index)
 const priorities=section==='customers'?['发券','手动续期']:section==='orders'?['查看','详情','发货','打印','派单']:['查看','编辑']
 const picked:number[]=[]
 for(const label of priorities){const found=normal.find(action=>!picked.includes(action.index)&&action.label.includes(label));if(found)picked.push(found.index);if(picked.length===2)break}
 for(const action of normal){if(picked.length===2)break;if(!picked.includes(action.index))picked.push(action.index)}
 return actions.filter(action=>action.fixed||picked.includes(action.index)).map(action=>action.index)
}
